<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <vs-popup classContent="popup-example" title="Agent" :active.sync="popup">
          <template>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full" label-placeholder="Name" v-model="name" />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full" label-placeholder="Prefix" v-model="prefix" />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full" label-placeholder="Username(email)" v-model="username" />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input class="w-full" label-placeholder="Password(>6)" v-model="password" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button class="mr-3 mb-2" @click="saveAgent">Save</vs-button>
            </div>
          </div>
        </template>
        </vs-popup>
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="Add()">
                <span class="flex items-center">
                  <feather-icon icon="UserPlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Add</span>
                </span>
              </vs-dropdown-item>

              <!--vs-dropdown-item @click="Delete()">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </!--vs-dropdown-item-->

              <!--vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </!--vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>-->

            </vs-dropdown-menu>
          </vs-dropdown>
      </div>


      <!-- AgGrid Table floatingFilter="true"-->
      <!--:onGridReady="onGridReady" -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererCreateDate from './cell-renderer/CellRendererCreateDate.vue'

import firebase from '@/services/saleData'
import 'firebase/database'
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: `agentManagement/getField`,
  mutationType: `agentManagement/updateField`,
});
export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererCreateDate
  },
  data () {
    return {
      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      roleOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ],

      statusFilter: { label: 'All', value: 'all' },
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' }
      ],

      isVerifiedFilter: { label: 'All', value: 'all' },
      isVerifiedOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'All', value: 'all' },
        { label: 'Sales', value: 'sales' },
        { label: 'Development', value: 'development' },
        { label: 'Management', value: 'management' }
      ],

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'Code Run',
          field: 'code',
          width: 150,
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Name',
          field: 'name',
          filter: true,
          width: 150
        },
        {
          headerName: 'Prefix',
          field: 'prefix',
          filter: true,
          width: 100
        },
        {
          headerName: 'Username',
          field: 'username',
          filter: true,
          width: 200
        },
        {
          headerName: 'Password',
          field: 'password',
          filter: true,
          width: 200
        },
        {
          headerName: 'User',
          field: 'user_count',
          filter: true,
          width: 100
        },
        {
          headerName: 'Createdate',
          field: 'createdate',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererCreateDate'
        },
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 150,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererCreateDate,
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  watch: {
    roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
    ...mapFields([
        'popup',
        'agent.name',
        'agent.prefix',
        'agent.username',
        'agent.password',
        'agent.code',
        'agent.key',
    ]),
    usersData () {
      return this.$store.state.agentManagement.agents
    },
    paginationPageSize () {
      //if (this.gridApi) return this.gridApi.paginationGetPageSize() else
      return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    onGridReady(params){
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        window.onresize = () => {
            this.gridApi.sizeColumnsToFit();
        }
    },
    confirmDeleteRecord (data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${data}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    async deleteRecord () {
      for(const data of this.gridApi.getSelectedRows()){
        const emailKey = data.email.trim().replace(/\./g, '||');
        await firebase.database().ref().child(`users/${emailKey}`).remove();
      }
      this.showDeleteSuccess()
      this.$store.dispatch('agentManagement/fetchUsers').catch(err => { console.error(err) })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    saveAgent(){
      this.$store.dispatch('agentManagement/saveAgent').catch(err => { console.error(err) })
    },
    Add(){
      this.$store.commit('agentManagement/SET_AGENT',{
        key:'',
        digit:0,
        code:0,
        name:'',
        username:'',
        password:'',
        prefix:'',
      });
      this.$store.commit('agentManagement/SET_POPUP',true);
      //this.$router.push('/management/agent/form')
    },
    Delete(){
      if(this.gridApi.getSelectedRows().length){
        let text = ''
        for(const data of this.gridApi.getSelectedRows()){
          text += (text)?', '+data.firstname:data.firstname
        }
        this.confirmDeleteRecord(text);
      }
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if(window.innerWidth>1000)
    setTimeout( ()=> this.gridApi.sizeColumnsToFit(), 0 );
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    this.$store.dispatch('agentManagement/fetchAgents').catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
